import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import request from '@/utils/request'

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/index.css'
import '@/assets/css/global.css'
import '@/assets/css/overwrite.css'
import 'animate.css'

import './plugins/element-ui'
import './plugins/vue-map'
import './plugins/vue-plyr'
import './plugins/common'
import './plugins/echart'

const api = axios.create({
  baseURL: 'https://api.xiyilab.com/v1',
  timeout: 5000
})

api.interceptors.request.use(
  config => {
    const { getToken, getShanxiToken } = require('@/utils/auth')
    const token = getToken() || getShanxiToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

Vue.prototype.$axios = api
Vue.prototype.$request = request
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')